import React from "react";

export default function Footer() {
  return (
    <footer className="admin-footer">
      <div>
        <span>© {new Date().getFullYear()} Gootocart E-Commerce Engine. All rights reserved.</span>
      </div>
      <div>
        <span className="badge bg-light text-dark border">Version 2.4.0-Production</span>
      </div>
    </footer>
  );
}
